import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const GuestMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [canReview, setCanReview] = useState(false);

  // Determine the API base URL based on the environment
  const getApiBaseUrl = () => {
    // Use the REACT_APP_API_URL from .env, fallback to localhost if not set
    return process.env.REACT_APP_API_URL || "http://localhost:8000";
  };

   useEffect(() => {
      const userId = localStorage.getItem("user_id");

      if (!userId) {
        console.log("No user ID found in localStorage");
        return;
      }

      // Get the auth token (adjust based on where you store it)
      const authToken = localStorage.getItem("token"); // or from your auth context

      if (!authToken) {
        console.error("No auth token found");
        setCanReview(false);
        return;
      }

      fetch(`${getApiBaseUrl()}/api/bookings/?guest_id=${userId}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Token ${authToken}`, // Add the token header
        },
      })
        .then(res => {
          if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
          return res.json();
        })
        .then(bookings => {
          //console.log("Received bookings:", bookings);

          // Today's date in YYYY-MM-DD (local time)
          const todayStr = new Date().toISOString().split('T')[0]; 

          const hasFinalized = bookings.some(booking => 
            booking?.end_date && todayStr > booking.end_date
          );

          console.log("Can review?", hasFinalized);
          setCanReview(hasFinalized);
        })
        .catch(err => {
          console.error("Failed to fetch bookings:", err);
          setCanReview(false);
        });
    }, []);

  const menuItems = [
    { name: t("profile"), path: "/guest/profile" },
    { name: t("bookings"), path: "/guest/bookings" },
    // Removed "reviews" from the main menuItems since we're conditionally rendering it
  ];

  return (
    <div className="fixed top-16 left-0 h-[calc(100vh-4rem)] w-48 bg-gray-800 text-white flex flex-col p-4 gap-4 overflow-y-auto z-30">
      <h2 className="text-xl font-bold p-4 border-b border-gray-600">{t("guest_panel")}</h2>
      <ul className="p-4 space-y-2">
        {menuItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`block p-3 rounded-lg ${
                location.pathname === item.path ? "bg-blue-500" : "hover:bg-gray-700"
              }`}
            >
              {item.name}
            </Link>
          </li>
        ))}
        {/* Conditionally render the Review button */}
        {canReview && (
          <li>
            <Link
              to="/guest/reviews"
              className={`block p-3 rounded-lg ${
                location.pathname === "/guest/reviews" ? "bg-blue-500" : "hover:bg-gray-700"
              }`}
            >
              {t("reviews")}
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default GuestMenu;